import { AssetId } from "./asset-id";
import { CameraId } from "./camera-id";
import { SiteId } from "./site-id";
import { TenantId } from "./tenant-id";

export type InstalledCamera = {
  tenant: TenantId;
  site: SiteId;
  asset: AssetId;
  camera: CameraId;
};
